<script setup lang="ts">
import { TabsTrigger, type TabsTriggerProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<TabsTriggerProps & { class?: string }>()
</script>

<template>
	<TabsTrigger
		v-bind="props"
		:class="
			cn(
				'ring-offset-background focus-visible:ring-ring data-[state=active]:bg-background data-[state=active]:text-foreground typography-s1-emp typography-s1-emp inline-flex items-center justify-center whitespace-nowrap border-b-2 border-n-100 px-12px py-16px transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-o-500 data-[state=active]:shadow-sm',
				props.class,
			)
		"
	>
		<slot />
	</TabsTrigger>
</template>
